import React from "react";
import { CSATTabs } from "../../../components/ProjectManagement/CSAT/CSATTabs";

const CSATRating = () => {
  return <CSATTabs />;
};

export default CSATRating;
